import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Index/Index';
import Submit from './views/Submit/Index';
import Empty from './views/Empty/Index';
import Webview from './views/Webview/Index';

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    //   redirect: "/submit",
    },
    {
      path: '/submit',
      name: 'submit',
      component: Submit,
    },
    {
      path: '/empty',
      name: 'empty',
      component: Empty,
    },
    {
      path: '/webview',
      name: 'webview',
      component: Webview,
    },
    // {
    //   path: '/common',
    //   component: { render: h => h('router-view') },
    //   children: [
    //     {
    //       path: 'about',
    //       name: 'about',
    //       // route level code-splitting
    //       // this generates a separate chunk (about.[hash].js) for this route
    //       // which is lazy-loaded when the route is visited.
    //       component: () => import(/* webpackChunkName: "about" */ './views/Common/About'),
    //     },
    //   ],
    // },
  ],
});
